export default __webpack_public_path__ + "static/patriotism_eng-min-aa1ed0e62331c65b61b8bada7107bd97.png";